import { Box, IconButton, Stack, Typography, styled } from '@mui/material';
import Visualiser from './components/Visualiser';

export const StyledRecorderContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.grey[100],
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
}));

export const StyledRecorderInner = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(4),
  alignItems: 'center',
}));

export const StyledAudio = styled('audio')(({ theme }) => ({
  height: theme.spacing(5),
  width: '100%',
  maxWidth: theme.spacing(30),
}));

export const StyledVisualiser = styled(Visualiser)(({ theme }) => ({
  height: theme.spacing(5),
  width: '100%',
  maxWidth: theme.spacing(30),
}));

export const StyledMcrophoneAccessMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[600],
  height: theme.spacing(5),
  width: '100%',
  maxWidth: theme.spacing(30),
  textAlign: 'center',
}));

export const StyledRecordingActions = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  gap: theme.spacing(1),
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  borderRadius: theme.spacing(0.5),
}));

export const StyledRejectButton = styled(StyledIconButton)(({ theme }) => ({
  background: theme.palette.error.light,
  '&:hover': {
    background: theme.palette.error.main,
  },
}));

export const StyledAcceptButton = styled(StyledIconButton)(({ theme }) => ({
  background: theme.palette.success.light,
  '&:hover': {
    background: theme.palette.success.main,
  },
}));
